import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import * as comparison from '../actions/comparison.actions';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { of } from 'rxjs/observable/of';
import { Api } from '../providers/api/api';

@Injectable()
export class ComparisonEffects {
  constructor(
    private api: Api,
    private actions$: Actions
  ) { }

  @Effect()
  loadCompanyComparisonData$: Observable<Action> = this.actions$
      .ofType(comparison.FETCH)
      .map((action: comparison.FetchCompanyForComparison) => {
        return action.payload;
      })
      .mergeMap(payload => {
        if (!payload) return of();
        return this.api.getCompanyComparisonData(payload.ticker)
      })
      .map(company => {
        return new comparison.FetchCompanyForComparisonSuccess(company)
      }
      ).catch((err) => of(new comparison.FetchCompanyForComparionsFail(err)));  
      
}


// WEBPACK FOOTER //
// ./src/effects/comparison.effects.ts